export default __webpack_public_path__ + "static/media/032-news anchor.8b640b38.svg";